<h2 mat-dialog-title class="dialog-header">
  <span class="dialog-title title-large">{{ 'receipts.ui.accontiESpese' | transloco }}</span>

  <button
    mat-icon-button
    mat-dialog-close
    type="button"
    [attr.aria-label]="'receipts.ui.chiudi' | transloco"
    class="close-button"
  >
    <i class="fa-regular fa-xmark"></i>
  </button>
</h2>

<mat-dialog-content class="content">
  <span class="body-medium">
    {{ 'receipts.ui.residuoDisponibile' | transloco }}
    <span class="body-medium-emphasized">{{ formatAmount(residuoDisponibile) }}</span>
  </span>

  @if (importoNonValido) {
    <div class="advance-error body-small" role="alert">
      <i class="fa-regular fa-circle-exclamation" aria-hidden="true"></i>
      <span>{{ 'receipts.ui.ilTotaleDegliAccontiSuperaLImportoDisponibile' | transloco }}</span>
    </div>
  }

  <div class="advance-list">
    @for (acconto of acconti; track acconto.codiceClienteErp + '-' + acconto.tipo) {
      <div class="advance-card">
        <div class="advance-card-header">
          <span class="body-small">
            {{ 'receipts.ui.codCliente' | transloco }}
            <span class="body-small-emphasized">{{ acconto.codiceClienteErp }}</span>
          </span>

          <span
            class="advance-type-badge label-small-emphasized"
            [class.advance-type-badge-oil]="acconto.tipo === 'OIL'"
            [class.advance-type-badge-non-oil]="acconto.tipo === 'NONOIL'"
          >
            {{ acconto.tipo === 'NONOIL' ? 'NON OIL' : acconto.tipo }}
          </span>
        </div>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ 'receipts.ui.importo' | transloco }}</mat-label>
          <span matTextPrefix>€&nbsp;</span>
          <input
            #amountInput
            matInput
            type="text"
            inputmode="decimal"
            [attr.value]="formatInputAmount(acconto.importo)"
            (focus)="prepareAmountInput(acconto, $event)"
            (input)="updateAmount(acconto, $event)"
            (blur)="commitAmount(acconto, $event)"
          />
          @if (acconto.importo > 0) {
            <button
              mat-icon-button
              matSuffix
              type="button"
              class="clear-amount-button"
              [attr.aria-label]="(('receipts.ui.svuotaImportoPerIlCliente' | transloco) + ' ') + acconto.codiceClienteErp"
              (click)="clearAmount(acconto, amountInput)"
            >
              <i class="fa-regular fa-xmark" aria-hidden="true"></i>
            </button>
          }
        </mat-form-field>
      </div>
    } @empty {
      <span class="advance-empty body-medium">{{ 'receipts.ui.nessunAccontoOSpesaDisponibile' | transloco }}</span>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions class="advance-actions">
  <div class="advance-total">
    <span class="body-medium">{{ 'receipts.ui.totaleAccontiSpese' | transloco }}</span>
    <span class="body-medium-emphasized">{{ formatAmount(totale) }}</span>
  </div>

  <button
    matButton="filled"
    type="button"
    [disabled]="importoNonValido"
    [mat-dialog-close]="acconti"
  >
    {{ 'receipts.ui.confermaImporto' | transloco }}
  </button>
</mat-dialog-actions>
